import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.einlasskontrolle-corona-check-codes';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleEinlasskontrolleCoronaCheckCodesEffects {

    EinlasskontrolleCoronaCheckCodes$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_EINLASSKONTROLLE_CORONA_CHECK_CODES),
        mergeMap((x: ac.GetEinlasskontrolleCoronaCheckCodesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getEinlasskontrolleCoronaCheckCodes().pipe(
                map((result: any) => {
                    return new ac.GetEinlasskontrolleCoronaCheckCodesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetEinlasskontrolleCoronaCheckCodesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleTemplatesService);
        }
        return this.service;
    }
}
